@if (isStartingSession()) {
  <app-page-loader message="Iniciando o jogo" />
} @else {
  <app-theme-picker
    title="Escolha um Tema"
    [themes]="themes()"
    [isLoading]="isLoadingThemes()"
    (themeSelect)="onThemeClick($event)"
    (back)="onBackClick()"
  />
}

@if (errorMessage(); as message) {
  <app-alert-modal [message]="message" (close)="errorMessage.set(null)" />
}
